import React from 'react';

import * as S from './styles';

const Slide10: React.FC = () => {
  return (
    <S.Container>
      <S.Credits>
        <S.Headline2>Créditos</S.Headline2>
        <S.Wrapper>
          <S.Column>
            <p>
              <span>Coord. de moda:</span>
              <br />
              Diego Tofolo
            </p>
            <p>
              <span>Produção de moda:</span>
              <br />
              Thiago Torres
            </p>
            <p>
              <span>Assistente de Produção de Moda:</span>
              <br />
              Amanda Cordeiro
            </p>
            <p>
              <span>Produção de arte e cenografia: </span>
              <br />
              Anderson Rodriguez
            </p>
            <p>
              <span>Assistentes de arte:</span>
              <br />
              Corinne Werner, Gilson Rezende e Leco Rezende
            </p>
            <p>
              <span>Assistentes de foto:</span>
              <br />
              Fabio Enes, Calebe Fernandes e Thiago Lima
            </p>
          </S.Column>
          <S.Column>
            <p>
              <span>Assistentes de beleza:</span>
              <br />
              Eduardo Evangelista, Filipe Baracho e Silvio Domingues
            </p>
            <p>
              <span>Manicure:</span>
              <br />
              Thayna Dandara
            </p>
            <p>
              <span>Produção executiva:</span>
              <br />
              Isabela de Paula
            </p>
            <p>
              <span>Tratamento de imagem:</span>
              <br />
              Philipe Mortosa
            </p>
            <p>
              <span>Vídeo:</span>
              <br />
              Guilherme Yoshida
            </p>
            <p>
              <span>Assistente de vídeo:</span>
              <br />
              Kim Olivier
            </p>
            <p>
              <span>Arte:</span>
              <br />
              Victor Aguiar Magalhães
            </p>
          </S.Column>
        </S.Wrapper>
      </S.Credits>
    </S.Container>
  );
};

export { Slide10 };
